/* eslint-disable import/prefer-default-export */
export class TarjetasHelper {
  static getRequestNewCardReason = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const perdidaElement = document.getElementById(
      'perdida',
    ) as HTMLInputElement;
    const familiaElement = document.getElementById(
      'familia',
    ) as HTMLInputElement;
    const estropeadaElement = document.getElementById(
      'estropeada',
    ) as HTMLInputElement;
    const isPerdida = perdidaElement?.checked;
    const isFamilia = familiaElement?.checked;
    const isEstropeada = estropeadaElement?.checked;
    let returnValue = -1;
    if (isPerdida) {
      returnValue = (perdidaElement.value as unknown) as number;
    } else if (isFamilia) {
      returnValue = (familiaElement.value as unknown) as number;
    } else if (isEstropeada) {
      returnValue = (estropeadaElement.value as unknown) as number;
    }
    return Number(returnValue);
  };

  static manageErrorLabel = (reason: number) => {
    const labelError = document.getElementById(
      'error-label',
    ) as HTMLLabelElement;
    if (reason === -1) {
      if (labelError !== null) {
        labelError.classList.remove('hide');
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (labelError !== null) {
        labelError.classList.add('hide');
      }
    }
  };

  static uncheckAll = () => {
    const perdidaElement = document.getElementById(
      'perdida',
    ) as HTMLInputElement;
    const familiaElement = document.getElementById(
      'familia',
    ) as HTMLInputElement;
    const estropeadaElement = document.getElementById(
      'estropeada',
    ) as HTMLInputElement;
    if (perdidaElement) {
      perdidaElement.checked = false;
    }
    if (familiaElement) {
      familiaElement.checked = false;
    }
    if (estropeadaElement) {
      estropeadaElement.checked = false;
    }
  };

  static getCorrectDataLang = (dataApp: any) => {
    const languaje = dataApp.lang;
    let dataLang = 'es-ES';
    if (languaje === 'eu') {
      dataLang = 'eu-ES';
    }
    if (languaje === 'ca') {
      dataLang = 'ca-ES';
    }
    if (languaje === 'gl') {
      dataLang = 'gl-ES';
    }
    if (languaje === 'es') {
      dataLang = 'es-ES';
    }

    return dataLang;
  };
}
